/** @prettier */
import { List } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setEventId } from '@xanadu/ui-shared/modules/application/actions';
import { getMatchedAmountForEventId } from '@xanadu/ui-shared/modules/bets/selectors';
import { requestEventBetbuilderData } from '@xanadu/ui-shared/modules/event/actions';
import {
  getAntePostTagForEventId,
  getCompetitionsForEventId,
} from '@xanadu/ui-shared/modules/event/selectors';
import { getCalendar } from '@xanadu/ui-shared/modules/events/actions';
import { getMarketsForEventId } from '@xanadu/ui-shared/modules/market/selectors';
import { getStream, minBetWarningRequest } from '@xanadu/ui-shared/modules/streaming/actions';
import { StreamInfo } from '@xanadu/ui-shared/modules/streaming/reducer';

import { triggerUpdateRightSidebar } from '../../../modules/rightSidebar/actions';

import DesktopLayout from '../../../components/SingleEventPage/DesktopLayout';

const streamRecord = new StreamInfo();

const mapDispatchToProps = {
  getCalendar,
  minBetWarningRequest,
  getStream,
  requestBetBuilderData: requestEventBetbuilderData,
  updateRightSidebar: triggerUpdateRightSidebar,
  setEventId,
};
const EMPTY_LIST = new List();

function mapStateToProps(state, { id }) {
  const event = state.getIn(['event', id]);
  const { eventId: streamAvailable, streamEnd } = state.getIn(
    ['streaming', 'streamInfo', id],
    streamRecord
  );

  const eventCompetition = getCompetitionsForEventId(state, id).first();

  const product = state.getIn(['application', 'product']);

  const betBuilderRestricted = state.getIn(['betBuilder', 'restricted']);
  const betBuilderAvailable = state.getIn(['betBuilder', 'available']);
  const { betbuilderEnabled, precannedBetslips: precannedBetBuilderData } = event.betbuilder;

  return {
    event,
    streamEnd,
    streamAvailable,
    eventCompetition,
    precannedBetBuilderData,
    betbuilderEnabled:
      !betBuilderRestricted && betbuilderEnabled && betBuilderAvailable && !event.inRunningFlag,
    events: state.getIn(['events', 'calendars']),
    markets: getMarketsForEventId(state, id, event.markets, product) || EMPTY_LIST,
    matchedAmount: getMatchedAmountForEventId(state, id),
    isAntePost: !!getAntePostTagForEventId(state, id),
    streamDetails: state.getIn(['streaming', 'stream', id]),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    sidebarVisible: state.getIn(['rightSidebar', 'visible']),
    tags: state.getIn(['navigation', 'tags']),
    bettingOpeningTime: state.getIn(['application', 'mbZeroConfig', 'bettingOpeningTime']),
    widthSize: state.getIn(['application', 'widthSize']),
    positions: state
      .get('positions')
      .filter((p) => p.eventId === id && (p.position || p.placePosition)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DesktopLayout));
